import { defineComponent as _defineComponent } from 'vue'
import { CourseModule } from '@/store/modules/course'
  import { UserModule } from '@/store/modules/user'
  import { computed, onMounted } from 'vue'
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import CourseProgressBar from '@/components/course/CourseProgressBar.vue'
  import useIcons from '@/composables/useIcons'
  import CourseDescription from '@/components/course/CourseDescription.vue'
  import useCourse from '@/composables/useCourse'
  import useSegment from '@/composables/useSegment'
  import CourseModuleStatusContainer from '@/components/course/CourseModuleStatusContainer.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import VideoOrImageRenderer from '@/components/course/VideoOrImageRenderer.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseStartPage',
  setup(__props) {

  const { course, completedModules, remainingModules } = useCourse()
  const { courseCertIcon } = useIcons()
  const { trackPage, pageViewed } = useSegment()
  const { isMobileDevice } = useBreakpoint()

  const userFirstName = computed(() => UserModule.firstName)

  const hasCourseModules = computed(() => {
    return (courseGroupId: string): number => {
      return CourseModule.numberOfCourseModules(course.value?.id || '', courseGroupId)
    }
  })

  const totalCourseGroupModules = computed(() => {
    return CourseModule.totalCourseGroupModules(
      course.value?.id || '',
      course.value?.courseGroups?.map((c) => c.id) || [],
    )
  })

  onMounted(() => {
    trackPage('Course Start')
    pageViewed('Course Start')
  })

return { __sfc: true,course, completedModules, remainingModules, courseCertIcon, trackPage, pageViewed, isMobileDevice, userFirstName, hasCourseModules, totalCourseGroupModules, CourseModule, UserModule, computed, onMounted, PlaceholderShimmer, CourseProgressBar, useIcons, CourseDescription, useCourse, useSegment, CourseModuleStatusContainer, useBreakpoint, VideoOrImageRenderer }
}

})